import './style.sass';

import parse from 'html-react-parser';
import React from 'react';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallText from '../../../common-components/common-small-text';
import CommonCircleList from '../../../common-components/common-circle-list';

const ServiceItem = ({
    serviceItem: { img, mainTitle, mainTitleDesc, title, link, text, list, isReversed },
}) => {
    let reverseMod = '';

    if (isReversed) {
        reverseMod = 'dev-rec-service-item--reversed';
    }

    return (
        <ScrollAnimation
            animateIn="fadeIn"
            offset={50}
            delay={100}
            animateOnce={true}
            duration={1}
            className={`dev-rec-service-item ${reverseMod}`}
        >
            <div className="dev-rec-service-item__img">
                <img src={img} alt="" loading="lazy" />
            </div>
            <div className="dev-rec-service-item__info">
                {mainTitle && (
                    <div className="dev-rec-service-item__subtitle-mode">
                        {mainTitle ? parse(mainTitle) : mainTitle}
                    </div>
                )}
                {mainTitleDesc && (
                    <>
                        <CommonSmallText className="dev-rec-service-item__text">
                            {parse(mainTitleDesc)}
                        </CommonSmallText>
                        <br />
                    </>
                )}
                <div className="dev-rec-service-item__title">{parse(title)}</div>
                {link && (
                    <a
                        href={link}
                        className="dev-rec-service-item__link"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                    >
                        {link}
                    </a>
                )}
                {text.map((item, index) => {
                    return (
                        <CommonSmallText key={index} className="dev-rec-service-item__text">
                            {parse(item)}
                        </CommonSmallText>
                    );
                })}
                {list && <CommonCircleList CommonCircleList={list} />}
            </div>
        </ScrollAnimation>
    );
};

export default ServiceItem;
